var map = {
	"./hangzhou/caifu-1.jpg": 1110,
	"./hangzhou/caifu-2.jpg": 7809,
	"./hangzhou/guoji-1.jpg": 5004,
	"./hangzhou/guoji-2.jpg": 6523,
	"./hangzhou/guoji-3.jpg": 686,
	"./hangzhou/guoji-4.jpg": 7749,
	"./hangzhou/guoji-5.jpg": 2920,
	"./hangzhou/suhehui-1.jpg": 8465,
	"./hangzhou/suhehui-2.jpg": 6326,
	"./hangzhou/suhehui-3.jpg": 1091,
	"./hangzhou/suhehui-4.jpg": 928,
	"./hangzhou/xingqitian-1.jpg": 3796,
	"./hangzhou/yanyu-1.jpg": 6082,
	"./jiaxing/yanyu-1.jpg": 8824,
	"./jiaxing/yanyu-2.jpg": 3575,
	"./jiaxing/yanyu-3.jpg": 9738,
	"./jiaxing/yanyu-4.jpg": 425,
	"./jiaxing/yanyu-5.jpg": 2380,
	"./jiaxing/yanyu-6.jpg": 8827,
	"./jiaxing/yanyu-7.jpg": 7342,
	"./shenyang/sanhao-1.jpg": 7975,
	"./shenyang/sanhao-2.jpg": 9304,
	"./shenyang/sanhao-3.jpg": 6917,
	"./shenyang/sanhao-4.jpg": 4030,
	"./shenyang/shidai-1.jpg": 9365,
	"./shenyang/shidai-2.jpg": 1514,
	"./shenyang/shidai-3.jpg": 2679,
	"./shenyang/shidai-4.jpg": 6364,
	"./tonglu/yanyu-1.jpg": 783,
	"./tonglu/yanyu-2.jpg": 7792,
	"./xian/fushi-1.jpg": 5521,
	"./xian/fushi-2.jpg": 5369,
	"./xian/fushi-3.jpg": 8803,
	"./xian/fushi-4.jpg": 7648,
	"./xian/fushi-5.jpg": 1101,
	"./zhuji/guoji-1.jpg": 1750,
	"./zhuji/hangsheng-1.jpg": 4745,
	"./zhuji/hangsheng-2.jpg": 3246,
	"./zhuji/hangsheng-3.jpg": 3403,
	"./zhuji/hangsheng-4.jpg": 8520,
	"./zhuji/lanbo-1.jpg": 6054,
	"./zhuji/lanbo-2.jpg": 8257,
	"./zhuji/lanbo-3.jpg": 6452,
	"./zhuji/lanbo-4.jpg": 4735,
	"./zhuji/lanbo-5.jpg": 3026,
	"./zhuji/lanbo-6.jpg": 2253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 465;